import React, { useEffect, useState, useCallback } from "react";
import { useDropzone } from 'react-dropzone';
import {
    Button,
} from "@chakra-ui/react";
import uploadPanorama from "api/room/upload-panorama";
import uploadLogo from "api/room/upload-logo";
import { ToastContainer, toast } from 'react-toastify';


export default function upload(props) {
    const { title, type, address, id, iframe,reload,setDisable  } = props
    const toastId = React.useRef([]);
    let option = {
        onDrop: useCallback(acceptedFiles => {
            setDisable(true)
            toastId.current[acceptedFiles[0].path] = toast.info("در حال بارگزاری ...", {
                closeButton: false,
                autoClose: false,
                isLoading: true,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                position: "bottom-right"
            })

            let callback = (percent) => {
                toast.update(toastId.current[acceptedFiles[0].path], { render: "در حال بارگزاری ..." + " " + percent + "%" })
            }
            if (type == "logo") {
                uploadLogo(acceptedFiles[0], address, id, callback).then((result) => {
                    toast.update(toastId.current[acceptedFiles[0].path], { render: "با موفقیت آپلود شد", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: 3000, closeButton: true, type: "success", isLoading: false, position: "bottom-right" });
                    iframe?.contentWindow?.postMessage("reload", "*");
                    setTimeout(() => {
                        toast.info("در حال پردازش", {
                            position: "bottom-right",
                            autoClose: 4000
                        })
                        setTimeout(() => {
                            if(iframe)
                            iframe?.contentWindow?.postMessage("open-gallery", "*");
                            else
                            location.reload();
                        }, 3000)
                    }, 2000)
                }).catch((err) => {
                    console.error(err)
                    toast.update(toastId.current[acceptedFiles[0].path], { render: err?.response?.data?.message?.pr, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: true, closeButton: true, type: "error", isLoading: false, position: "bottom-right" });
                }).finally(() => {
                    setDisable(false)
                })
            } else {
                let night = false;
                if (type == "night") night = true
                uploadPanorama(acceptedFiles[0], address, id, night, callback).then((result) => {
                    toast.update(toastId.current[acceptedFiles[0].path], { render: "با موفقیت آپلود شد", hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: 3000, closeButton: true, type: "success", isLoading: false, position: "bottom-right" });
                    setTimeout(() => {
                        toast.info("در حال پردازش", {
                            position: "bottom-right",
                            autoClose: 4000
                        })
                        reload();
                        // iframe.contentWindow.postMessage("reload", "*");

                        // setTimeout(() => {
                        //      iframe.contentWindow.postMessage("close-gallery", "*");
                        //      iframe.contentWindow.postMessage((night ? "night" : "day") + "-mode", "*");
                        // }, 2000)
                    }, 1000)
                }).catch((err) => {
                    console.error(err)
                    toast.update(toastId.current[acceptedFiles[0].path], { render: err?.response?.data?.message?.pr, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, autoClose: true, closeButton: true, type: "error", isLoading: false, position: "bottom-right" });
                }).finally(() => {
                    setDisable(false)
                })
            }
        }, []),
        maxFiles: 1,
        multiple: false,
        accept: {
           
            'image/jpg': ['.jpg'],
            
        }
    }

    const {
        getRootProps,
        getInputProps
      } = useDropzone(option);
    return (
        <Button {...getRootProps()} disabled={props.disabled} fontSize={props.fontSize} w={props.w} mt={props.mt} mb={props.mb} m={props.m} leftIcon={props.leftIcon} bg={props.bg} mr={props.mr}>
             <input {...getInputProps()} />
            {title}
        </Button>
    )

}